/** True for the Knowledge Graph route (`/business-knowledge`). */
export function isKnowledgeGraphRoute(pathname: string): boolean {
  return (
    pathname === '/business-knowledge' ||
    pathname.startsWith('/business-knowledge/')
  )
}
